// This must be in sync with src/types/flags.ts -
// Any changes here should be reflected there as well
export type FeatureFlagKey = 'streamability' | 'chatHistory' | 'agentManager';
export const featureFlags: Record<FeatureFlagKey, boolean> = {
  chatHistory: true,
  streamability: false,
  agentManager: false,
};
